/**
 * Calculates the size of the element the hook was added to and then pushes an
 * event to LiveView with the size. Can take an optional target to push to.
 *
 * ### Example
 *
 *    <div
 *      id="my-element-#{i}"
 *      phx-hook="ElementSize"
 *      data-target={@myself}> // Optional
 *
 *    def handle_event("element-size", %{"height" => h, "width" => w} = size, socket)
 *
 */
export const ElementSize = {
  mounted() {
    size = { height: this.el.offsetHeight, width: this.el.offsetWidth };

    if (this.el.dataset.target) {
      this.pushEventTo(this.el.dataset.target, "element-size", size);
    } else {
      this.pushEvent("element-size", size);
    }
  },
};
